
<mat-card *ngIf="exhibitionData?.length" class="pdf-card">

  <!-- Header Section -->
  <div class="header-section text-center">

    <div class="d-flex justify-content-between align-items-center">
      <img src="assets/Images/RAMP_LOGO.jpg" width="80" />
      <div>
        <h2 class="title">
          Maharashtra Small Scale Industries Development Corporation Ltd.
        </h2>
        <p class="subtitle">A Government Of Maharashtra Undertaking</p>
        <p class="cin">CIN No. U74999MH1962SGC012501</p>
      </div>
      <img src="assets/Images/logo_icon.png" width="80" />
    </div>


    <hr class="thick-line" />

    <h3 class="form-title">EOI Exhibition Registration Details</h3>

  </div>

  <!-- Red Strip -->
  <div class="red-strip"></div>

  <!-- Data Table -->
  <table class="details-table" *ngIf="exhibitionData[0]?.registrationType == null">

    <tr>
      <th>MSME / Artisan Name</th>
      <td>{{exhibitionData[0]?.MsmEName}}</td>
      <th>Aadhaar Number</th>
      <td>{{exhibitionData[0]?.AadhaarNumber}}</td>
    </tr>

    <tr>
      <th>Organization Type</th>
      <td>{{exhibitionData[0]?.OrganizationTypeName}}</td>
      <th>Year Of Establishment</th>
      <td>{{exhibitionData[0]?.YearOfEstablishment}}</td>
    </tr>

    <tr>
      <th>Udyam / Artisan Certificate Number</th>
      <td>{{exhibitionData[0]?.UdyamOrArtisanCardNo}}</td>
      <th>Industry Sector</th>
      <td>{{exhibitionData[0]?.IndustrySector}}</td>
    </tr>

    <tr>
      <th>Social Category</th>
      <td>{{exhibitionData[0]?.SocialCategoryName}}</td>
      <th>Gender</th>
      <td>{{exhibitionData[0]?.Gender}}</td>
    </tr>

    <tr>
      <th>Registered Address</th>
      <td>{{exhibitionData[0]?.RegisteredAddress}}</td>
      <th>District</th>
      <td>{{exhibitionData[0]?.DistrictName}}</td>
    </tr>

    <tr>
      <th>Pin Code</th>
      <td>{{exhibitionData[0]?.PinCode}}</td>
      <th>Contact Person</th>
      <td>{{exhibitionData[0]?.ContactPersonName}}</td>
    </tr>

    <tr>
      <th>Mobile Number</th>
      <td>{{exhibitionData[0]?.MobileNumber}}</td>
      <th>Email</th>
      <td>{{exhibitionData[0]?.EmailAddress}}</td>
    </tr>

    <tr>
      <th>Product Description</th>
      <td colspan="3">{{exhibitionData[0]?.ProductServiceDescription}}</td>
    </tr>

  </table>


   <table class="details-table" *ngIf="exhibitionData[0]?.registrationType !== null">

<tr>
  <th>Registration Type</th>
  <td>{{ exhibitionData[0]?.registrationType }}</td>

  <th>
    {{
      exhibitionData[0]?.registrationType === 'MSME'
        ? 'Udyam Number'
        : 'Artisan Number'
    }}
  </th>
  <td>
    {{
      exhibitionData[0]?.registrationType === 'MSME'
        ? (exhibitionData[0]?.udyamNumber || '-')
        : (exhibitionData[0]?.artisanNumber || '-')
    }}
  </td>
</tr>
<tr>
  <th>Industry Sector</th>
  <td >
    {{ getIndustrySector(exhibitionData[0]) }}
  </td>
  <th>Other</th>
<td>{{ exhibitionData[0]?.industrySectorOther || '-' }}</td>
</tr>

  <tr>
  <!-- <th>
    {{
      exhibitionData[0]?.registrationType === 'MSME'
        ? 'MSME Name'
        : 'Artisan Name'
    }}
  </th>
  <td>{{ exhibitionData[0]?.MsmEName || '-' }}</td>
 <td>{{ exhibitionData[0]?.artisanNumber || '-' }}</td> -->


  <th>
    {{
      exhibitionData[0]?.registrationType === 'MSME'
        ? 'MSME Name'
        : 'Artisan Name'
    }}
  </th>

  <td>
    {{
      exhibitionData[0]?.registrationType === 'MSME'
        ? (exhibitionData[0]?.MsmEName || '-')
        : (exhibitionData[0]?.artisanNumber || '-')
    }}
  </td>

  <th>Aadhaar Number</th>
  <td>{{ exhibitionData[0]?.AadhaarNumber || '-' }}</td>
   
    </tr>

    

    <tr>
      <th>Organization Type</th>
      <td>{{exhibitionData[0]?.OrganizationTypeName}}</td>
      <th>Year Of Establishment</th>
      <td>{{exhibitionData[0]?.YearOfEstablishment}}</td>
    </tr>


    <tr>
      <th>Social Category</th>
      <td>{{exhibitionData[0]?.SocialCategoryName}}</td>
      <th>Gender</th>
      <td>{{exhibitionData[0]?.Gender}}</td>
    </tr>

    <tr>
      <th>Registered Address</th>
      <td>{{exhibitionData[0]?.RegisteredAddress}}</td>
      <th>District</th>
      <td>{{exhibitionData[0]?.DistrictName}}</td>
    </tr>

    <tr>
      <th>Pin Code</th>
      <td>{{exhibitionData[0]?.PinCode}}</td>
      <th>Contact Person</th>
      <td>{{exhibitionData[0]?.ContactPersonName}}</td>
    </tr>

    <tr>
      <th>Mobile Number</th>
      <td>{{exhibitionData[0]?.MobileNumber}}</td>
      <th>Email</th>
      <td>{{exhibitionData[0]?.EmailAddress}}</td>
    </tr>

    <tr>
      <th>Product Description</th>
      <td colspan="3">{{exhibitionData[0]?.ProductServiceDescription}}</td>
    </tr>

  </table>



  <!-- File Section -->
  <hr />

  <h4 class="mt-3">Attached Documents</h4>

  <div class="row mt-2">

    <div class="col-md-6">
      <p>
        <strong>Udyam / Artisan Certificate:</strong>
        <!--<a *ngIf="exhibitionData[0]?.UdyamFilePath"
           [href]="baseUrl + exhibitionData[0].UdyamFilePath"
           target="_blank">
          View
        </a>-->

        <a (click)="openFile(exhibitionData[0].UdyamFilePath)"
           style="cursor:pointer; color:blue;">
          View
        </a>
        <span *ngIf="!exhibitionData[0]?.UdyamFilePath">-</span>
      </p>
    </div>

    <div class="col-md-6">
      <p>
        <strong>Caste Certificate:</strong>
        <!--<a *ngIf="exhibitionData[0]?.CasteFilePath"
           [href]="baseUrl + exhibitionData[0].CasteFilePath"
           target="_blank">
          View
        </a>-->

        <a (click)="openFile(exhibitionData[0].CasteFilePath)"
           style="cursor:pointer; color:blue;">
          View
        </a>
        <span *ngIf="!exhibitionData[0]?.CasteFilePath">-</span>
      </p>
    </div>

  </div>

  <div class="row mt-2">

    <div class="col-md-6">
      <p>
        <strong>Photo:</strong>
        <!--<a *ngIf="exhibitionData[0]?.PhotoFilePath"
           [href]="baseUrl + exhibitionData[0].PhotoFilePath"
           target="_blank">
          View
        </a>-->

        <a (click)="openFile(exhibitionData[0].PhotoFilePath)"
           style="cursor:pointer; color:blue;">
          View
        </a>
        <span *ngIf="!exhibitionData[0]?.PhotoFilePath">-</span>
      </p>
    </div>

    <div class="col-md-6">
      <p>
        <strong>Video:</strong>
        <a (click)="openFile(exhibitionData[0].VideoFilePath)"
           style="cursor:pointer; color:blue;">
          View
        </a>

        <span *ngIf="!exhibitionData[0]?.VideoFilePath">-</span>
      </p>
    </div>

  </div>
  <div class="row">
    <div class="col-md-4">
      <button class="btn btn-info" (click)="back()">Back</button>
    </div>
  </div>
</mat-card>
